module.exports = __webpack_public_path__ + "static/media/instagram.62b234f8.png";